import { FC } from "react";

import { BoxProps } from "@mui/material";
import { createPortal } from "react-dom";

import { useLiveFormEditorContext } from "./LiveFormEditorContext";

import { useArrow } from "@/components/LiveEditorElements/AnimatePreview/Arrow/ArrowContext";
import {
  LiveEditorActionFooter,
  NextButtonLabel,
} from "@/components/LiveEditorElements/LiveEditorActionFooter/LiveEditorActionFooter";

export type { NextButtonLabel };

export interface StepActionFooterProps extends BoxProps {
  onBack?: () => void;
  backButtonLabel?: string;
  onNext?: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  nextButtonLabel?: NextButtonLabel;
  customNextButtonLabel?: string;
}

export const LiveFormEditorActionFooter: FC<StepActionFooterProps> = (props) => {
  const { isStepChanging } = useLiveFormEditorContext();
  const { hideArrow } = useArrow();

  return (
    <LiveEditorActionFooter {...props} isStepChanging={isStepChanging} onNavigationStart={hideArrow} skipAutocapture />
  );
};

/**
 * Portal to render the footer in a stable DOM location (LiveEditorLayout)
 * while being controlled by StepContainer.
 * This allows the mobile ProgressBar to stay outside of Steps, ensuring stable animations.
 */
export const LiveFormActionFooterPortal: FC<StepActionFooterProps> = (props) => {
  const { footerPortalNode } = useLiveFormEditorContext();
  if (!footerPortalNode) {
    return null;
  }

  return createPortal(<LiveFormEditorActionFooter {...props} />, footerPortalNode);
};

export const LiveFormActionFooterRef: FC = () => {
  const { setFooterPortalNode } = useLiveFormEditorContext();

  return <div ref={setFooterPortalNode} style={{ display: "contents" }} />;
};
